import styled from "styled-components";

export const Container = styled.div<{ isRCPortal?: boolean }>`
  display: flex;
  flex-direction: row;
  margin: 0 auto;
  width: 100%;
  padding:${({ isRCPortal }) => isRCPortal ? '3rem 0.75rem' : '0 0.75rem 3rem'} ;
`;

export const ImageWrapper = styled.figure`
  flex: 0 0 auto;
  width: 25%;
  padding: 0 1.2rem;
  margin: 0;
  text-align: center;
`;

export const ContentWrapper = styled.article<{ isRCPortal?: boolean, isMobileView?: boolean }>`
  flex: 0 0 auto;
  width: ${({ isRCPortal, isMobileView }) => isRCPortal && !isMobileView ? 'calc(100% - 30rem)' : isRCPortal && isMobileView ? '100%' : '66.66%'} ;
  padding: 0 1.2rem;

  .content-para {
    font-size: 1.6rem;
    line-height: 1.5;
    color: #000;
    margin-bottom: 2.4rem;
  }

  .btn-wrapper {
    margin-bottom: 2.4rem;

    .btn-primary:hover {
      text-decoration: underline;
    }
  }
`;
export const Heading = styled.h1<{ isRCPortal?: boolean }>`
font-size: ${({ isRCPortal }) => isRCPortal ? '3.5rem' : '2.8rem'};
line-height: 1.2;
margin-bottom: 1.5rem;
`
export const ActionWrapper = styled.aside`
flex: 25%;
max-width: 30rem;
`
